import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { MapPin, Newspaper, User, PlusCircle } from 'lucide-react';

const Layout = () => {
    return (
        <div className="flex flex-col h-screen bg-gray-100">
            <main className="flex-1 overflow-y-auto pb-16">
                <Outlet />
            </main>

            <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 shadow-lg z-50">
                <div className="flex justify-around items-center h-16">
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`
                        }
                    >
                        <MapPin size={24} />
                        <span className="text-xs font-medium">Local Events</span>
                    </NavLink>

                    <NavLink
                        to="/classifieds"
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`
                        }
                    >
                        <Newspaper size={24} />
                        <span className="text-xs font-medium">Classifieds</span>
                    </NavLink>

                    <NavLink
                        to="/create-listing"
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`
                        }
                    >
                        <PlusCircle size={24} className="text-blue-600" />
                        <span className="text-xs font-medium text-blue-600">Post</span>
                    </NavLink>

                    <NavLink
                        to="/profile"
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`
                        }
                    >
                        <User size={24} />
                        <span className="text-xs font-medium">Profile</span>
                    </NavLink>
                </div>
            </nav>
        </div>
    );
};

export default Layout;
